import styled from 'styled-components';

export const LineChartWidgetStyled = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
`;
